import React from 'react'

const AgentProfileImageContent = ({ image, content, team }) => (
  <section className='agent-image-content'>
    <div className='agent-image-content__inner'>
      <div className='agent-image-content__image'>
        <img src={image?.sourceUrl} alt={`Kollosche - ${team?.title}`} />
      </div>
      <div className='agent-image-content__content'>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  </section>
)

AgentProfileImageContent.defaultProps = {
  image: null,
  team: null,
  content: '',
}

export default AgentProfileImageContent